import { Home, Calendar, Utensils, Package, Trophy, MapPin, Users, User, Activity, Settings, TrendingUp, Dumbbell, MessageSquare, UsersRound, Swords, BrainCircuit, DollarSign } from 'lucide-react';

export const getRoleLinks = (role, t) => {
  if (role === 'coach') {
    return [
      { to: '/coach/dashboard', icon: Home, label: t('nav.dashboard') },
      { to: '/coach/plans', icon: Calendar, label: t('coach.plans') },
      { to: '/coach/sessions', icon: Users, label: t('coach.sessions') },
      { to: '/feed/global', icon: MessageSquare, label: t('nav.feed') },
      { to: '/profile', icon: User, label: t('nav.profile') },
    ];
  }

  if (role === 'admin') {
    return [
      { to: '/admin/dashboard', icon: Home, label: t('nav.dashboard') },
      { to: '/admin/users', icon: Users, label: t('admin.users') },
      { to: '/admin/payments', icon: DollarSign, label: t('admin.payments') },
      { to: '/profile', icon: User, label: t('nav.profile') },
    ];
  }

  return [
    { to: '/dashboard', icon: Home, label: t('nav.dashboard') },
    { to: '/trainings', icon: Activity, label: t('nav.trainings') },
    { to: '/training/planner', icon: BrainCircuit, label: t('nav.aiPlanner') },
    { to: '/progress', icon: TrendingUp, label: t('nav.progress') },
    { to: '/matches', icon: Trophy, label: t('nav.matches') },
    { to: '/fitness', icon: Dumbbell, label: t('nav.fitness') },
    { to: '/schedule', icon: Calendar, label: t('nav.schedule') },
    { to: '/nutrition', icon: Utensils, label: t('nav.nutrition') },
    { to: '/equipment', icon: Package, label: t('nav.equipment') },
    { to: '/tournaments', icon: Trophy, label: t('nav.tournaments') },
    { to: '/courts', icon: MapPin, label: t('nav.courts') },
    { to: '/opponents', icon: Users, label: t('nav.opponents') },
    { to: '/matchmaking', icon: Swords, label: t('nav.matchmaking') },
    { to: '/feed/global', icon: MessageSquare, label: t('nav.feed') },
    { to: '/clubs', icon: UsersRound, label: t('nav.clubs') },
    { to: '/achievements', icon: Trophy, label: t('nav.achievements') },
    { to: '/notifications', icon: Settings, label: t('nav.notifications') },
    { to: '/profile', icon: User, label: t('nav.profile') },
    { to: '/subscription', icon: DollarSign, label: t('nav.subscription') },
  ];
};

export const getMobilePrimaryLinks = (role, t) => {
  if (role === 'coach') {
    return [
      { to: '/coach/dashboard', icon: Home, label: t('nav.home') },
      { to: '/coach/sessions', icon: Users, label: t('coach.sessions') },
      { to: '/coach/plans', icon: Calendar, label: t('coach.plans') },
      { to: '/profile', icon: User, label: t('nav.profile') },
    ];
  }

  if (role === 'admin') {
    return [
      { to: '/admin/dashboard', icon: Home, label: t('nav.home') },
      { to: '/admin/users', icon: Users, label: t('admin.users') },
      { to: '/admin/payments', icon: DollarSign, label: t('admin.payments') },
      { to: '/profile', icon: User, label: t('nav.profile') },
    ];
  }

  return [
    { to: '/dashboard', icon: Home, label: t('nav.home') },
    { to: '/schedule', icon: Calendar, label: t('nav.schedule') },
    { to: '/feed/global', icon: MessageSquare, label: t('nav.feed') },
    { to: '/profile', icon: User, label: t('nav.profile') },
  ];
};
